import api from './api';
import { CPB_URL } from './servers';

export const fetchDevices = () => api.post(`${CPB_URL}/dispositivos/getDispositivos`, {});

export const fetchDevicesUnassigned = () =>
  api.post(`${CPB_URL}/dispositivos/getDispoNoAsignados`, {});

export const fetchDevicesAssigned = () => api.post(`${CPB_URL}/dispositivos/getDispoAsignados`, {});

export const saveDevices = (data) => api.post(`${CPB_URL}/dispositivos/postDispos`, data);

export const saveAssignDevice = (data) =>
  api.post(`${CPB_URL}/dispositivos/postAsignarDispo`, data);

export const deleteAssignment = (data) => api.post(`${CPB_URL}/dispositivos/postDeleteAsign`, data);

export const deleteDevice = (data) => api.post(`${CPB_URL}/dispositivos/postDeleteDispo`, data);

export const editAssignDevice = (data) => api.post(`${CPB_URL}/dispositivos/postEditAsign`, data);
